import './index.scss';

import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';

const ErrorList = ({ errors, onRemove, onClearAll }) => {
	const [leavingIds, setLeavingIds] = useState(new Set());
	const timeoutsRef = useRef(new Map());

	useEffect(() => {
		const activeTimeouts = timeoutsRef.current;
		return () => {
			activeTimeouts.forEach((timeoutId) => clearTimeout(timeoutId));
			activeTimeouts.clear();
		};
	}, []);

	const handleRemove = (id) => {
		setLeavingIds(prev => new Set(prev).add(id));

		const timeoutId = setTimeout(() => {
			onRemove(id);
			setLeavingIds(prev => {
				const copy = new Set(prev);
				copy.delete(id);
				return copy;
			});
			timeoutsRef.current.delete(id);
		}, 200);
		timeoutsRef.current.set(id, timeoutId);
	};

	if (errors.length === 0) return null;

	return (
		<div className="error-list">
			{errors.map(({ id, text }) => (
				<div key={id}
				     className={`error-banner${leavingIds.has(id) ? ' exit' : ''}`}>
					<span className="error-text">{text}</span>
					<button className="error-close" onClick={() => handleRemove(id)}>×</button>
				</div>
			))}

			{errors.length > 1 && (
				<button className="clear-all-errors" onClick={onClearAll}>Clear All</button>
			)}
		</div>
	);
};

ErrorList.propTypes = {
	errors: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.any.isRequired,
			text: PropTypes.string.isRequired
		})
	).isRequired,
	onRemove: PropTypes.func.isRequired,
	onClearAll: PropTypes.func.isRequired,
};

export default ErrorList;
